import React, { FC, useState } from 'react'
import { Button } from 'react-bootstrap';
import Sidebar from './Sidebar';
import Timeline from './Timeline';
import Widget from './Widget';
import useMediaQuery from '@mui/material/useMediaQuery';
import { colors, createMuiTheme, createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { Container } from '@mui/system';


const Home=()=> {
  const [isAuth,setIsAuth]=useState(false);
  return (
    <div className='home'>
         <Sidebar />
         <Timeline />
         <Widget/>
    </div>
  )
}

export default Home